import * as React from "react";
import { ManageAccessToken } from "../../../components";

export const ManageAccessTokenContainer: React.FC = () => {
    return <ManageAccessToken />;
};
